import React from "react";
import Avatar from "@mui/material/Avatar";
export const Founders = () => {
  return (
    <div className="approch  founder container pb-5">
      <div className="row">
        <div className="col-lg-12 text-center" data-aos="fade-up" data-aos-delay="200">
          {/* <button className="btn-gradient mb-3">We’re hiring!</button> */}
          <div className="text-center d-flex align-items-center justify-content-center">
            <h2 className="text-gradient">Meet our founders</h2>
          </div>
          <p>An experienced team of serial entrepreneurs</p>
        </div>
        <div className="row mt-5">
          <div className="col-lg-6 mb-4">
            <div className="cards d-flex flex-wrap flex-md-nowrap align-items-center gap-3 p-4" data-aos="fade-up" data-aos-delay="300">
              <Avatar
                sx={{ height: 80, width: 80 }}
                alt="Eneko"
                src="/images/Eneko.png"
              />
              <div>
                <h2>Eneko Knorr</h2>
                <span>CEO</span>

                <p>
                  Eneko has over 25 years of entrepreneurship experience in Europe and Silicon Valley, including successful exits and founding Spain’s leading crypto custodian, Onyze. He is also a Professor of Crypto at IE Business School and an Angel Investor.

                </p>
                <div className="d-flex align-items-center gap-3">
                  {/* <svg
                    width="22"
                    height="18"
                    viewBox="0 0 22 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.74287 17.5789C14.6759 17.5789 19.0162 11.0048 19.0162 5.30554C19.0162 5.12073 19.0121 4.9318 19.0039 4.74699C19.8482 4.1364 20.5768 3.38009 21.1555 2.51361C20.3692 2.86346 19.5343 3.09195 18.6794 3.19126C19.5796 2.6517 20.2535 1.80407 20.5764 0.805514C19.7296 1.30737 18.8035 1.66138 17.8379 1.85238C17.1873 1.16105 16.327 0.703309 15.3901 0.549925C14.4533 0.39654 13.4919 0.556057 12.6548 1.00381C11.8177 1.45157 11.1514 2.16263 10.7589 3.02705C10.3664 3.89147 10.2696 4.86111 10.4835 5.78606C8.76884 5.70001 7.09139 5.25459 5.55991 4.47866C4.02842 3.70273 2.6771 2.61361 1.59353 1.28192C1.04281 2.23144 0.874282 3.35503 1.12221 4.42433C1.37014 5.49363 2.01592 6.42841 2.9283 7.03869C2.24334 7.01694 1.57339 6.83252 0.973786 6.50067V6.55406C0.973172 7.55051 1.31765 8.51642 1.94867 9.2876C2.57969 10.0588 3.4583 10.5876 4.43516 10.7843C3.80065 10.9579 3.1347 10.9832 2.48885 10.8582C2.7645 11.7151 3.30081 12.4646 4.02294 13.0021C4.74507 13.5396 5.61698 13.8382 6.51699 13.8563C4.98904 15.0565 3.10158 15.7075 1.1586 15.7044C0.814029 15.7039 0.469798 15.6828 0.127747 15.6412C2.1016 16.9075 4.39773 17.5801 6.74287 17.5789Z"
                      fill="#98A2B3"
                    />
                  </svg> */}
                  <a href="https://www.linkedin.com/in/enekoknorr/" target="_blank">
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_458_447)">
                        <path
                          d="M20.449 0.522217H2.53019C1.67183 0.522217 0.977753 1.19987 0.977753 2.0377V20.0304C0.977753 20.8682 1.67183 21.55 2.53019 21.55H20.449C21.3073 21.55 22.0055 20.8682 22.0055 20.0345V2.0377C22.0055 1.19987 21.3073 0.522217 20.449 0.522217ZM7.21627 18.441H4.09496V8.40353H7.21627V18.441ZM5.65561 7.0359C4.65351 7.0359 3.84443 6.22682 3.84443 5.22883C3.84443 4.23083 4.65351 3.42175 5.65561 3.42175C6.65361 3.42175 7.46269 4.23083 7.46269 5.22883C7.46269 6.22272 6.65361 7.0359 5.65561 7.0359ZM18.8965 18.441H15.7793V13.5619C15.7793 12.3996 15.7588 10.9006 14.1571 10.9006C12.5348 10.9006 12.2884 12.1696 12.2884 13.4798V18.441H9.1753V8.40353H12.1652V9.77526H12.2063C12.6211 8.98672 13.6396 8.153 15.1551 8.153C18.3134 8.153 18.8965 10.2311 18.8965 12.9335V18.441Z"
                          fill="#98A2B3"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_458_447">
                          <rect
                            width="21.0278"
                            height="21.0278"
                            fill="white"
                            transform="translate(0.977753 0.522217)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                  {/* <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.3416 0.522217C5.53734 0.522217 0.827759 5.2318 0.827759 11.0361C0.827759 16.8404 5.53734 21.55 11.3416 21.55C17.1345 21.55 21.8555 16.8404 21.8555 11.0361C21.8555 5.2318 17.1345 0.522217 11.3416 0.522217ZM18.2863 5.36864C19.5406 6.89669 20.2933 8.84665 20.3161 10.9563C20.0196 10.8993 17.0547 10.2949 14.067 10.6712C13.9986 10.523 13.9416 10.3633 13.8732 10.2037C13.6907 9.77037 13.4855 9.32563 13.2802 8.90369C16.5872 7.55811 18.0924 5.61951 18.2863 5.36864ZM11.3416 2.07307C13.6223 2.07307 15.7091 2.92833 17.2942 4.33094C17.1345 4.559 15.7775 6.37214 12.5846 7.56948C11.1136 4.86689 9.48292 2.65464 9.23204 2.31254C9.90479 2.15289 10.6119 2.07307 11.3416 2.07307ZM7.52156 2.91692C7.76101 3.23621 9.35748 5.45987 10.8513 8.10543C6.65487 9.22299 2.94878 9.20018 2.54966 9.20018C3.13123 6.41775 5.01279 4.10287 7.52156 2.91692ZM2.35581 11.0475C2.35581 10.9563 2.35581 10.8651 2.35581 10.7739C2.74352 10.7852 7.0996 10.8423 11.5811 9.49668C11.8434 9.99839 12.0829 10.5115 12.311 11.0247C12.1969 11.0589 12.0714 11.0931 11.9574 11.1273C7.32767 12.6211 4.86455 16.7036 4.65928 17.0456C3.23386 15.4606 2.35581 13.351 2.35581 11.0475ZM11.3416 20.0219C9.26621 20.0219 7.35048 19.3149 5.83383 18.129C5.99348 17.7983 7.81798 14.2861 12.8811 12.5186C12.9039 12.5071 12.9153 12.5071 12.9381 12.4958C14.2039 15.7685 14.7171 18.5167 14.8539 19.3035C13.7706 19.771 12.5846 20.0219 11.3416 20.0219ZM16.3477 18.4825C16.2565 17.9351 15.7775 15.3124 14.603 12.0852C17.4197 11.6405 19.8827 12.3703 20.1907 12.473C19.803 14.9703 18.3661 17.1255 16.3477 18.4825Z"
                      fill="#98A2B3"
                    />
                  </svg> */}
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 mb-4">
            <div className="cards  p-4" data-aos="fade-up" data-aos-delay="300">
              <div className=" d-flex  flex-wrap flex-md-nowrap align-items-center gap-3">
                <Avatar
                  sx={{ height: 80, width: 80 }}
                  alt="julian"
                  src="/images/julian.png"
                />
                <div>
                  <h2>Julian Beltran</h2>
                  <span>CTO</span>
                  <p>
                    Julian has been a tech entrepreneur for over 20 years, leading 3 startups to successful exits. He is a software engineer renowned for his expertise in market making and algorithmic trading in crypto and Web3 platform architecture.

                  </p>
                  <div className="d-flex align-items-center gap-3">
                    {/* <svg
                      width="22"
                      height="18"
                      viewBox="0 0 22 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.74287 17.5789C14.6759 17.5789 19.0162 11.0048 19.0162 5.30554C19.0162 5.12073 19.0121 4.9318 19.0039 4.74699C19.8482 4.1364 20.5768 3.38009 21.1555 2.51361C20.3692 2.86346 19.5343 3.09195 18.6794 3.19126C19.5796 2.6517 20.2535 1.80407 20.5764 0.805514C19.7296 1.30737 18.8035 1.66138 17.8379 1.85238C17.1873 1.16105 16.327 0.703309 15.3901 0.549925C14.4533 0.39654 13.4919 0.556057 12.6548 1.00381C11.8177 1.45157 11.1514 2.16263 10.7589 3.02705C10.3664 3.89147 10.2696 4.86111 10.4835 5.78606C8.76884 5.70001 7.09139 5.25459 5.55991 4.47866C4.02842 3.70273 2.6771 2.61361 1.59353 1.28192C1.04281 2.23144 0.874282 3.35503 1.12221 4.42433C1.37014 5.49363 2.01592 6.42841 2.9283 7.03869C2.24334 7.01694 1.57339 6.83252 0.973786 6.50067V6.55406C0.973172 7.55051 1.31765 8.51642 1.94867 9.2876C2.57969 10.0588 3.4583 10.5876 4.43516 10.7843C3.80065 10.9579 3.1347 10.9832 2.48885 10.8582C2.7645 11.7151 3.30081 12.4646 4.02294 13.0021C4.74507 13.5396 5.61698 13.8382 6.51699 13.8563C4.98904 15.0565 3.10158 15.7075 1.1586 15.7044C0.814029 15.7039 0.469798 15.6828 0.127747 15.6412C2.1016 16.9075 4.39773 17.5801 6.74287 17.5789Z"
                        fill="#98A2B3"
                      />
                    </svg> */}
                    <a href="https://www.linkedin.com/in/julianmb/" target="_blank">
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_458_447)">
                          <path
                            d="M20.449 0.522217H2.53019C1.67183 0.522217 0.977753 1.19987 0.977753 2.0377V20.0304C0.977753 20.8682 1.67183 21.55 2.53019 21.55H20.449C21.3073 21.55 22.0055 20.8682 22.0055 20.0345V2.0377C22.0055 1.19987 21.3073 0.522217 20.449 0.522217ZM7.21627 18.441H4.09496V8.40353H7.21627V18.441ZM5.65561 7.0359C4.65351 7.0359 3.84443 6.22682 3.84443 5.22883C3.84443 4.23083 4.65351 3.42175 5.65561 3.42175C6.65361 3.42175 7.46269 4.23083 7.46269 5.22883C7.46269 6.22272 6.65361 7.0359 5.65561 7.0359ZM18.8965 18.441H15.7793V13.5619C15.7793 12.3996 15.7588 10.9006 14.1571 10.9006C12.5348 10.9006 12.2884 12.1696 12.2884 13.4798V18.441H9.1753V8.40353H12.1652V9.77526H12.2063C12.6211 8.98672 13.6396 8.153 15.1551 8.153C18.3134 8.153 18.8965 10.2311 18.8965 12.9335V18.441Z"
                            fill="#98A2B3"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_458_447">
                            <rect
                              width="21.0278"
                              height="21.0278"
                              fill="white"
                              transform="translate(0.977753 0.522217)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                    {/* <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M11.3416 0.522217C5.53734 0.522217 0.827759 5.2318 0.827759 11.0361C0.827759 16.8404 5.53734 21.55 11.3416 21.55C17.1345 21.55 21.8555 16.8404 21.8555 11.0361C21.8555 5.2318 17.1345 0.522217 11.3416 0.522217ZM18.2863 5.36864C19.5406 6.89669 20.2933 8.84665 20.3161 10.9563C20.0196 10.8993 17.0547 10.2949 14.067 10.6712C13.9986 10.523 13.9416 10.3633 13.8732 10.2037C13.6907 9.77037 13.4855 9.32563 13.2802 8.90369C16.5872 7.55811 18.0924 5.61951 18.2863 5.36864ZM11.3416 2.07307C13.6223 2.07307 15.7091 2.92833 17.2942 4.33094C17.1345 4.559 15.7775 6.37214 12.5846 7.56948C11.1136 4.86689 9.48292 2.65464 9.23204 2.31254C9.90479 2.15289 10.6119 2.07307 11.3416 2.07307ZM7.52156 2.91692C7.76101 3.23621 9.35748 5.45987 10.8513 8.10543C6.65487 9.22299 2.94878 9.20018 2.54966 9.20018C3.13123 6.41775 5.01279 4.10287 7.52156 2.91692ZM2.35581 11.0475C2.35581 10.9563 2.35581 10.8651 2.35581 10.7739C2.74352 10.7852 7.0996 10.8423 11.5811 9.49668C11.8434 9.99839 12.0829 10.5115 12.311 11.0247C12.1969 11.0589 12.0714 11.0931 11.9574 11.1273C7.32767 12.6211 4.86455 16.7036 4.65928 17.0456C3.23386 15.4606 2.35581 13.351 2.35581 11.0475ZM11.3416 20.0219C9.26621 20.0219 7.35048 19.3149 5.83383 18.129C5.99348 17.7983 7.81798 14.2861 12.8811 12.5186C12.9039 12.5071 12.9153 12.5071 12.9381 12.4958C14.2039 15.7685 14.7171 18.5167 14.8539 19.3035C13.7706 19.771 12.5846 20.0219 11.3416 20.0219ZM16.3477 18.4825C16.2565 17.9351 15.7775 15.3124 14.603 12.0852C17.4197 11.6405 19.8827 12.3703 20.1907 12.473C19.803 14.9703 18.3661 17.1255 16.3477 18.4825Z"
                        fill="#98A2B3"
                      />
                    </svg> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
